import React, { useState, useEffect } from 'react'
import AppTopbar from '../components/Headers/AppTopbar';

export default function Header({ logout, usrName, locations, reload, usrRole }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <AppTopbar
            logout={logout}
            usrName={usrName}
            locations={locations}
            reload={reload}
            usrRole={usrRole}
            isMobile={isMobile}
        />
    );
}
